import api from "../apiConfig";
const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};

const url = "/api/v1/advance-payment";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(params) {
    const p = paramsFactory(params);
    return api.get(`${url}?${p}`);
  },
  getById(id) {
    return api.get(`${url}/${id}`);
  },
  create(data) {
    return api.post(`${url}`, data);
  },
  update(data) {
    return api.put(`${url}/${data.id}`, data);
  },
  partialPay(data) {
    return api.put(`${url}/pay/${data.id}`, data);
  },
  delete(id) {
    return api.delete(`${url}/${id}`);
  },
};
